export type InterviewTypeSummary = {
    client: number;
    proactive: number;
};

export type InterviewTypeClassification = "PROACTIVE" | "CLIENT";

// The term is matched exactly as written (with the space), so companies such as
// "TalentPool" are not treated as proactive.
export const TALENT_POOL_TERM = "talent pool";

export function isTalentPoolCompany(company: unknown): boolean {
    if (typeof company !== "string") {
        return false;
    }

    return company.toLowerCase().includes(TALENT_POOL_TERM);
}

export function classifyInterviewType(company: unknown): InterviewTypeClassification {
    return isTalentPoolCompany(company) ? "PROACTIVE" : "CLIENT";
}

export function buildInterviewTypeSummary(companies: unknown[]): InterviewTypeSummary {
    return companies.reduce(
        (summary: InterviewTypeSummary, company: unknown) => {
            if (classifyInterviewType(company) === "PROACTIVE") {
                summary.proactive += 1;
                return summary;
            }

            summary.client += 1;
            return summary;
        },
        { client: 0, proactive: 0 }
    );
}
